import { pbiMockDataEnabledAtom } from "../../state/pbi.atoms";

// Mirrors the shared Power BI source choice for existing dashboard hooks.
export const hullPaintsMockEnabledAtom = pbiMockDataEnabledAtom;
